import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mobile-warning',
  templateUrl: './mobile-warning.component.html',
  styleUrls: ['./mobile-warning.component.scss']
})
export class MobileWarningComponent {
  message: string

  constructor(
    private translate: TranslateService,
    private router : Router
  ) {
    this.message = this.translate.instant("common.mobile_warning")
  }

  
  submit() {

    this.router.navigateByUrl('/vizadata')
  }
}
